<template>
    <div id="logs">
        <div class="panel">
            <div class="panel-head">
                <h2>Event Log</h2>

                <ul class="actions">
                    <li>
                        <button @click="showLogCreate = true" class="action">New Log</button>
                    </li>
                </ul>
            </div>

            <div class="panel-content">

                <div id="archive-toggle">
                    <label class="switch">
                        <input type="checkbox" v-model="showArchived">
                        <span class="slider"></span>
                    </label>
                    <span class="switch-text">Show Archived</span>
                </div>
                <br>
                <p v-if="filteredLogs.length == 0"><em>No Logs to show</em></p>
                <div v-else class="table">
                    <div class="table-row header">
                        <div class="table-cell">Type</div>
                        <div class="table-cell">Description</div>
                        <div class="table-cell">Created On</div>
                        <div class="table-cell">Submitted By</div>
                        <div v-if="showArchived" class="table-cell">Archived By</div>
                        <div class="table-cell"></div>
                    </div>

                    <a href="#" v-for="log in filteredLogs" @click.prevent="editLog(log)" class="table-row log">
                        <div class="table-cell">
                            <span class="type" :class="log.type.toLowerCase()">{{ log.type }}</span>
                        </div>
                        <div class="table-cell description">{{ log.description }}</div>
                        <div class="table-cell">{{ log.created_at | moment('MMM D, Y')}}</div>
                        <div class="table-cell">{{ log.created_by }}</div>
                        <div v-if="showArchived">{{ log.archived_by || '--' }}</div>
                        <div class="table-cell">
                            <a @click.prevent.stop="archive(log)" href="#"><i class="fa fa-check"></i></a>
                            <a @click.prevent.stop="destroy(log)" class="delete" href="#"><i class="fa fa-trash"></i></a>
                        </div>
                    </a>

                </div>

            </div>
        </div>

        <log-create :show="showLogCreate" @update="update()" @close="showLogCreate = false"></log-create>
        <log-edit :show="showLogEdit" :log="selectedLog" @update="update()" @close="showLogEdit = false"></log-edit>
    </div>
</template>

<script>
import LogCreate from './LogCreate'
import LogEdit from './LogEdit'

export default {
    name: 'Logs',
    props: ['budget'],
    components: {
        LogCreate,
        LogEdit
    },
    data() {
        return {
            showArchived: false,
            showLogCreate: false,
            showLogEdit: false,
            selectedLog: {}
        }
    },
    computed: {
        filteredLogs() {
            return this.budget.client.paid_media_logs.filter(log => {

                if(this.showArchived) {
                    return true
                }

                if(!this.showArchived && log.archived_by) {
                    return false
                }

                return true
            })
        }
    },
    methods: {
        update() {
            this.$emit('update')
        },
        editLog(log) {
            this.selectedLog = JSON.parse(JSON.stringify(log))
            this.showLogEdit = true
        },
        async archive(log) {
            let response = await this.$http.put('/paid-media-budgets/' + this.$route.params.clientId + '/logs/' + log.id, { archive: true })

            this.$emit('update')
        },
        async destroy(log) {
            if(window.confirm('Are you sure you want to delete this log?')) {
                let response = await this.$http.delete('/paid-media-budgets/' + this.$route.params.clientId + '/logs/' + log.id)

                this.$emit('update')
            }
        }
    }
}
</script>

<style lang="scss">
#logs {
    .switch {
        margin-left: 5px;
    }

    .switch-text {
        display: inline-block;
        margin-left: 5px;
        margin-bottom: 5px;
        font-size: 12px;
        vertical-align: middle;
    }

    .table {
        display: table;
        width: 100%;
        border-spacing: 0;
    	border-collapse: collapse;

        .table-row {
            display: table-row;
            border-top: 1px solid $light-gray;

            &:nth-of-type(2n) {
                background: #f9f9f9;
            }

            &:hover {
                background: lighten($blue, 50%);
            }
        }

        .header {
            font-weight: 700;
            border-top: none;
        }

        .table-cell {
            display: table-cell;
            padding: 5px;
            color: $black;
            text-decoration: none;

            &:last-of-type {
                text-align: right;
            }

            &.description {
                max-width: 320px;
            }
        }
    }

    .log {
        td:last-of-type {
            text-align: right;
        }

        .type {
            padding: 0 5px;
            border-radius: 3px;
            color: $white;
            font-size: 12px;
            font-weight: 700;

            &.followup {
                background: $green;
            }

            &.billing.hold {
                background: $orange;
            }

            &.cancellation {
                background: $red;
            }

            &.notes {
                background: $blue;
            }
            &.excess.funds {
              background: $red;
            }
        }

    }

    a {
        color: $dark-gray;
        padding-right: 15px;

        &:hover {
            color: $blue;

            &.delete {
                color: $red;
            }
        }
    }
}
</style>
